var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryToc = function SvgCategoryToc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 14,
    fill: "#EBDFF4",
    transform: "rotate(-90 21 21)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.667,
    cy: 39.667,
    r: 9.333,
    fill: "#EBDFF4",
    transform: "rotate(-90 39.667 39.667)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.167,
    cy: 44.333,
    r: 2.333,
    fill: "#EBDFF4",
    transform: "rotate(-90 15.167 44.333)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#664B96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M21.69 41.616a3.346 3.346 0 0 0 3.252 2.56c.924 0 1.673-.749 1.673-1.673v-6.522h1.764a2.93 2.93 0 0 0 2.932-2.933v-2.474c3.154-.377 6.62-.993 9.182-1.49 2.25-.437 3.84-2.42 3.84-4.71v-3.611c0-1.987-1.196-3.753-3.004-4.463m-2.107-.567c-2.723-.666-6.11-1.424-9.064-1.875-2.54-.388-5.937-.73-9.05-.996-4.485-.385-8.274 3.188-8.274 7.69v3.01c0 3.815 2.73 6.986 6.332 7.612l1.59 6.581m7.055-6.851c.535-.04 1.053-.081 1.546-.126v2.27c0 .54-.438.978-.978.978h-.568z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#664B96",
    strokeWidth: 1.3,
    d: "M24.846 18.902a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM24.846 24.357a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM19.835 21.862a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#664B96",
    d: "M21.8 39.65a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0"
  })));
};
export default SvgCategoryToc;